import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type AddTargetsToAdUpdate } from "zodios/apiDefinitions/api/ads";
import { toast } from "react-toastify";
import { successToast } from "utils/toasts";
import { toTitleCase } from "utils/formatText";

export const useAddTargetsToAd = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: AddTargetsToAdUpdate) => await apiClient.addTargetsToAd(payload),
    onMutate: (vars: AddTargetsToAdUpdate) => {
      toast.info(
        `Updating Media Plan ${vars.data.target_type === "product" ? "Target" : toTitleCase(vars.data.target_type)}s`,
        {
          autoClose: 3000,
          toastId: "ad-status-toast",
        },
      );
    },
    onSuccess: (data, variables) => {
      const { target_type } = variables.data;
      successToast({
        message: `${target_type === "product" ? "Target" : toTitleCase(target_type)}s Successfully Added`,
      });
      void queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes("keyword_report") ||
          query.queryKey.includes("keyword_report_meta") ||
          query.queryKey.includes("adPlanConfig"),
      });
    },
  });
};
